import React, { useState, createContext } from 'react'

export const LoaderContext = createContext(null)

export const LoaderProvider = (props) => {
    const [showLoader, setShowLoader] = useState(false)
    return (
        <LoaderContext.Provider value={[showLoader, setShowLoader]}>
            {props.children}
        </LoaderContext.Provider>
    )
}
